import { Search } from 'lucide-react'
import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'

interface SearchInputProps {
	value: string
	onChange: (value: string) => void
	placeholder?: string
	className?: string
}

/**
 * Search input with a leading magnifier icon.
 * Accepts a plain string `onChange` (no synthetic event) for ergonomic usage.
 */
export function SearchInput({
	value,
	onChange,
	placeholder,
	className,
}: SearchInputProps) {
	return (
		<div className={cn('relative', className)}>
			<Search className="absolute left-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
			<Input
				value={value}
				onChange={(e) => onChange(e.target.value)}
				placeholder={placeholder}
				className="pl-9"
			/>
		</div>
	)
}
